module.exports = __webpack_public_path__ + "img/back-arrow.6d4f6450.svg";